import React from "react";
import PropTypes from "prop-types";
import radium from "radium";
import Button from "backpack-ui/dist/components/button";
import Textarea from "backpack-ui/dist/components/textarea";
import Switch from "backpack-ui/dist/components/switch";
import styles from "../../pois/components/styles";

const AddEditList = ({
  nameOnChange,
  nameValue,
  privacyChecked,
  privacyToggle,
  onSave,
  onCancel,
  disableSaveButton,
}) => (
  <div style={styles.fieldset}>
    <div>
      <label
        style={styles.label}
        htmlFor="list-name"
      >
        List name
      </label>

      <Textarea
        id="list-name"
        name="list_name"
        placeholder="List name"
        onChange={nameOnChange}
        value={nameValue}
        maxLines={3}
        autofocus
        autogrow
      />
    </div>

    <div style={styles.field}>
      <div style={styles.label}>Privacy</div>

      <div style={styles.switch}>
        <label htmlFor="privacy-control">
          Appears in your public profile
        </label>

        <Switch
          id="privacy-control"
          name="privacy_control"
          value="private"
          checked={privacyChecked}
          onClick={privacyToggle}
        />
      </div>
    </div>

    <footer style={styles.fieldsetFooter}>
      <Button
        onClick={onCancel}
        customStyles={styles.desktopSaveButton}
        color="gray"
        rounded
        border
      >
        Cancel
      </Button>

      <Button
        onClick={onSave}
        disabled={disableSaveButton}
        customStyles={styles.desktopSaveButton}
        rounded
      >
        Save
      </Button>
    </footer>
  </div>
);

AddEditList.propTypes = {
  nameOnChange: PropTypes.func.isRequired,
  privacyToggle: PropTypes.func.isRequired,
  privacyChecked: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  disableSaveButton: PropTypes.bool.isRequired,
  nameValue: PropTypes.string,
};

AddEditList.defaultProps = {
  nameValue: "",
};

export default radium(AddEditList);



// WEBPACK FOOTER //
// ./assets/shared/components/addEditList.jsx